export default __webpack_public_path__ + "static/banner-1-2-5e580cf9fa2fccde92aa63ba8659f807.jpg";